import { useIntl } from 'react-intl'
import styled from 'styled-components'
import ChatPreviewLoadingSkeleton from './ChatPreviewLoadingSkeleton'
import Group from 'components/utils/Group'
import useChats from 'supportAssistant/hooks/useChats'
import { useAppSelector } from 'hooks/reduxHooks'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import { rem } from 'polished'
import clsx from 'clsx'
import LuxuryEscapesSmallLogo from 'components/App/Header/Logo/logos/LuxuryEscapesSmallLogo'
import AgentAvatar from '../Support/AgentAvatar'
import { useIntlDateFormatter } from 'lib/datetime/dateUtils'

const ChatHistory = styled(Group)`
  overflow: auto;
`

const StyledListItem = styled(ClickableListItem)`
  border-bottom: 1px solid ${props => props.theme.palette.neutral.default.five};

  &.is-active {
    background-color: ${props => props.theme.palette.highlight.secondary.lightBackground};
  }
`

const Avatar = styled.div`
  grid-column: 1;
  grid-row: 1 / span 2;
  width: ${rem(24)};
  height: ${rem(24)};
  align-self: start;
`

interface Props {
  onChatSelect: (chatId: string) => void
}

function ChatsHistoryList(props: Props) {
  const { onChatSelect } = props
  const intl = useIntl()
  const dateFormatter = useIntlDateFormatter()

  const [chats, fetching] = useChats()
  const currentChatId = useAppSelector(state => state.supportAssistant.currentChatId)

  return (
    <ChatHistory direction="vertical">
      {fetching && (
        <ChatPreviewLoadingSkeleton />
      )}
      {!fetching && chats?.map(chat => (
        <StyledListItem
          key={chat.id}
          startIcon={
            <Avatar>
              {chat.agentType !== 'AGENT' && <LuxuryEscapesSmallLogo height={24} width={24} />}
              {chat.agentType === 'AGENT' && <AgentAvatar width={24} height={24} />}
            </Avatar>
          }
          title={chat.title}
          subtitle={intl.formatMessage(
            {
              id: 'w8dc-_cMD9f6Y5JS1mVS',
              defaultMessage: 'Last updated at {date}',
              description: 'Subtitle showing when a chat was last updated in chat history list',
            },
            {
              date: dateFormatter(chat.lastMessageAt || chat.createdAt, {
                hour: 'numeric',
                minute: 'numeric',
                day: 'numeric',
                month: 'short',
              }),
            },
          )}
          className={clsx({ 'is-active': chat.id === currentChatId })}
          onClick={() => onChatSelect(chat.id)}
        />
      ))}
    </ChatHistory>
  )
}

export default ChatsHistoryList
